import React, {useState} from 'react'

import Formulario from './Formulario'
import Alerta from './Alerta'

import '../../styles/formulario-contacto.css'

const FormularioSeccion = ({english}) => {
    const [alerta, setAlerta] = useState({
        status: false,
        message: '',
        type: ''
    })
    const [sending, setSending] = useState(false)

    const showAlert = (message, type) => {
        setAlerta({
            status: true,
            message: message,
            type: type
        })
        setTimeout(() => {
            setAlerta({
                status: false,
                message: '',
                type: ''
            })
        }, 5000)
    }

    return (
        <div className={`formulario-contacto `} id="contacto" >
            <h3 className="encabezado">{english ? 'Contact' : 'Contacto'}</h3>
            <div className="info">
                <p className="texto">
                    {english ?
                            'One of our advisors will contact you shortly.'
                        :
                            'Uno de nuestros asesores se pondrá en contacto contigo en breve.'
                    }                    
                </p>
                <div className="infoDetalle">
                    <img alt="" src="/images/ubicacion.png" className="icono"/>
                    {english ?
                            <p className="texto">                        
                                Sales office <br/>
                                Blvd Cabo Marques, Lote 1, Punta Diamante, 39907, Acapulco Guerrero, Mexico
                            </p>    
                        :
                            <p className="texto">                        
                                Oficina de ventas <br/>
                                Blvd Cabo Marques, Lote 1, Punta Diamante, 39907, Acapulco Guerrero, México
                            </p>
                    }                    
                </div>
                <div className="infoDetalle">
                    <img alt="" src="/images/whatsapp.png" className="icono"/>
                    <p className="texto">
                    Whatsapp + 52 55 2128 3106
                    </p>
                </div>
                <div className="infoDetalle">
                    <img alt="" src="/images/telefono.png" className="icono"/>
                    <p className="texto">
                        {english ? 'Office' : 'Oficina'} 744 434 0133
                    </p>
                </div>
                <div className="infoDetalle">
                    <img alt="" src="/images/email.png" className="icono"/>
                    <p className="texto">
                        {english ? 'sales@gmdresorts.mx' : 'ventas@gmdresorts.mx'}
                    </p>
                </div>
            </div>
            <Formulario english={english} showAlert={showAlert} status={sending} setSending={setSending} />
            {alerta.status ?
                <Alerta {...alerta} />
                : null
            }
        </div>
    )
}

export default FormularioSeccion